
import { UX } from '../Constant'
export default {
  name: 'FeedbackResult',
  props: {
    name: String,
    phone: String,
    email: String,
    ip: String,
    pageUrl: String,
    userAgent: String,
    step1: {
      type: Object,
      default: () => ({})
    },
    step2: {
      type: Object,
      default: () => ({})
    },
    step3: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    UX() {
      return UX
    }
  }
}
